var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgGoal(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512.004 512.004",
    style: {
      enableBackground: "new 0 0 512.004 512.004"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FEC9A3"
    },
    d: "M256.002,70.846L256.002,70.846c-14.62,0-26.47-11.85-26.47-26.47v-26.47L220.71,0.26h44.116 c9.75,0,17.646,7.897,17.646,17.646v26.47C282.472,58.996,270.622,70.846,256.002,70.846z"
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "#787D82"
    },
    points: "220.71,159.077 220.71,282.602 308.941,282.602 291.295,264.956 291.295,159.077 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4398D1"
    },
    d: "M326.588,123.785V88.492c0-9.75-7.897-17.646-17.646-17.646H185.417V18.877 c0.353-8.956-5.859-16.843-14.646-18.617c-9.6-1.659-18.732,4.782-20.39,14.391c-0.185,1.076-0.274,2.171-0.256,3.256v61.762 c0,14.62,11.85,26.47,26.47,26.47h44.116v52.939h70.585v-26.47c0,14.62,11.85,26.47,26.47,26.47h61.762 c9.75,0,17.646-7.897,17.646-17.646l0,0c0-9.75-7.897-17.646-17.646-17.646C379.527,123.785,326.588,123.785,326.588,123.785z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616569"
    },
    d: "M261.208,282.602h24.881l-21.264-21.264v-75.791h-17.646v79.409 c-0.018,2.347,0.909,4.597,2.559,6.264L261.208,282.602z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#DE4C3C"
    },
    points: "361.88,62.023 441.289,26.73 361.88,0.26 "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 353.101,
    y: 0.26,
    style: {
      fill: "#D9D9D9"
    },
    width: 17.646,
    height: 299.988
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#3E8CC7"
    },
    points: "344.234,256.132 326.588,256.132 317.764,282.602 203.063,282.602 150.124,353.187  114.831,353.187 0.13,512.004 511.874,512.004 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3582BD"
    },
    d: "M379.527,317.895c-70.585,97.055-176.464,158.817-291.694,194.11h424.042L379.527,317.895z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D9D9D9"
    },
    d: "M88.362,123.785c-4.888,0.035-9.723,1.05-14.205,3c-17.911-16.517-45.819-15.396-62.336,2.515 c-7.482,8.117-11.655,18.74-11.691,29.778h123.524C123.655,139.587,107.852,123.785,88.362,123.785z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D9D9D9"
    },
    d: "M476.582,194.37c-2.673,0.009-5.338,0.335-7.941,0.971c-7.747-6.256-17.391-9.714-27.352-9.794 c-24.361,0-44.116,19.755-44.116,44.116h114.701C511.874,210.172,496.072,194.37,476.582,194.37z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D9D9D9"
    },
    d: "M150.124,256.132c0-19.49-15.802-35.293-35.293-35.293l0,0c-19.49,0-35.293,15.802-35.293,35.293 H150.124z"
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#4398D1"
    },
    points: "247.179,414.95 211.886,353.187 150.124,353.187 114.831,353.187 0.13,512.004  354.028,512.004 300.118,414.95 "
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoal);
export default __webpack_public_path__ + "static/media/goal.6a32a8ae5a8fc920b279890bda979691.svg";
export { ForwardRef as ReactComponent };